"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _a, _b;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var ParagraphSizeEnum;

(function (ParagraphSizeEnum) {
  ParagraphSizeEnum["extraSmall"] = "extraSmall";
  ParagraphSizeEnum["small"] = "small";
  ParagraphSizeEnum["normal"] = "normal";
  ParagraphSizeEnum["big"] = "big";
  ParagraphSizeEnum["large"] = "large";
})(ParagraphSizeEnum = exports.ParagraphSizeEnum || (exports.ParagraphSizeEnum = {}));

var FontSizes = (_a = {}, _a[ParagraphSizeEnum.extraSmall] = 10, _a[ParagraphSizeEnum.small] = 12, _a[ParagraphSizeEnum.normal] = 16, _a[ParagraphSizeEnum.big] = 18, _a[ParagraphSizeEnum.large] = 20, _a);
var LineHeights = (_b = {}, _b[ParagraphSizeEnum.small] = 20, _b[ParagraphSizeEnum.normal] = 22, _b[ParagraphSizeEnum.big] = 26, _b[ParagraphSizeEnum.large] = 32, _b);
exports.Paragraph = styled_components_1.default(function (_a) {
  var centered = _a.centered,
      size = _a.size,
      bold = _a.bold,
      customLineHeight = _a.customLineHeight,
      color = _a.color,
      rest = __rest(_a, ["centered", "size", "bold", "customLineHeight", "color"]);

  return react_1.default.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: Roboto;\n    font-size: ", "px;\n    line-height: ", "px;\n    color: ", ";\n    text-align: ", ";\n    font-weight: ", ";\n"], ["\n    font-family: Roboto;\n    font-size: ", "px;\n    line-height: ", "px;\n    color: ", ";\n    text-align: ", ";\n    font-weight: ", ";\n"])), function (_a) {
  var size = _a.size;
  return size ? FontSizes[size] : FontSizes[ParagraphSizeEnum.normal];
}, function (_a) {
  var size = _a.size,
      customLineHeight = _a.customLineHeight;
  return customLineHeight ? customLineHeight : size ? LineHeights[size] : LineHeights[ParagraphSizeEnum.normal];
}, function (props) {
  return props.color || props.theme.colors.title;
}, function (_a) {
  var centered = _a.centered;
  return centered ? 'center' : 'left';
}, function (_a) {
  var bold = _a.bold;
  return bold ? 'bold' : 'normal';
});
exports.ParagraphItalic = styled_components_1.default(exports.Paragraph)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-style: italic;\n"], ["\n    font-style: italic;\n"])));
var templateObject_1, templateObject_2;